/* ============================================================================
 * HELLIX ONDERCONSTRUCTIE CALCULATOR — CONFIGURATIE & REKENREGELS
 * ----------------------------------------------------------------------------
 * Alle rekenregels staan bewust in dit ENE bestand zodat ze zonder de rest van
 * de code aan te raken aangepast kunnen worden.
 *
 * Bron productdata: vault Projecten/Hellix-merk-launch/Hellix/Products/
 *                   01-PRODUCT-DATABASE.md (26 SKU's, v1.0 2026-05-29)
 *
 * BELANGRIJK:
 *  - De tool levert EXACTE aantallen per stuk (geen VPE/verpakkingsafronding).
 *  - Variant-ID's worden NIET hier hardcoded; de Liquid-sectie levert een
 *    runtime SKU->variant map (window.HELLIX_VARIANT_MAP) uit collections.hellix.
 *  - Regels gemarkeerd met VALIDEREN MET TOM zijn nette standaardwaarden die nog
 *    door Tom bevestigd moeten worden a.d.h.v. de montagehandleidingen. De tool
 *    werkt er meteen mee.
 * ==========================================================================*/

window.HELLIX_CALC_CONFIG = {

  /* --- Paneelmaat-presets (mm) ------------------------------------------- */
  panelPresets: [
    { id: "p-1722", label: "1722 × 1134 mm", wp: "≈ 415-430 Wp", length: 1722, width: 1134 },
    { id: "p-1762", label: "1762 × 1134 mm", wp: "≈ 430-450 Wp", length: 1762, width: 1134 },
    { id: "p-2278", label: "2278 × 1134 mm", wp: "≈ 530-580 Wp", length: 2278, width: 1134 },
  ],
  // Eigen maat: gebruiker vult length+width (mm) zelf in -> id "p-custom".

  /* --- Montage-parameters (VALIDEREN MET TOM) ---------------------------- */
  mounting: {
    railsPerRow: 2,              // standaard 2 rails per paneelrij
    panelGapMm: 20,              // tussenruimte tussen panelen op de rail
    rowGapMm: 20,                // verticale ruimte tussen rijen
    railOverhangMm: 150,         // rail steekt aan elke kant buiten de rij uit
    hookSpacingMaxMm: 1200,      // VALIDEREN: max h.o.h. afstand dakhaak/beugel
    endClampsPerRailEnd: 1,      // 1 eindklem per uiteinde van een rail-lijn
    boltsPerHook: 1,             // bout + groefmoer per dakhaak/beugel
    boltsPerClamp: 1,            // groefmoer per klem (klem schuift in railsleuf)
    endCapsPerRailLine: 2,       // 2 eindkappen per doorlopende rail-lijn
    boltsPerCoupler: 4,          // groefmoer/bouten per koppelstrip (VALIDEREN)
  },

  /* --- Beschikbare rail-lengtes per railtype (mm) ------------------------ */
  rails: {
    alu: [
      { sku: "HX-RA-475", lengthMm: 4750 },
      { sku: "HX-RA-590", lengthMm: 5900 },
      { sku: "HX-RA-710", lengthMm: 7100 },
    ],
    aluBlack: [
      { sku: "HX-RA-590-ZW", lengthMm: 5900 },
    ],
    steeldeck: [
      { sku: "HX-SD-RA-610", lengthMm: 6100 },
    ],
    couplerSku: "HX-BV-KS",
    endCapSku:  "HX-BV-EK",
  },

  /* --- Klemmen (universeel) ---------------------------------------------- */
  clamps: {
    end:    { sku: "HX-KL-EK-35-ZW" },
    middle: { sku: "HX-KL-MK-28-ZW" },
  },

  /* --- Daktype-configuraties --------------------------------------------- */
  roofTypes: {
    pannendak: {
      label: "Schuin pannendak",
      railType: "alu",
      anchor: {
        sku: "HX-DH-VS",
        label: "Dakhaak verstelbaar",
        boltSku: "HX-BV-BT-820",
        nutSku:  "HX-BV-GM-8",
      },
    },
    steeldeck: {
      label: "Staaldak (steeldeck)",
      railType: "steeldeck",
      anchor: {
        sku: "HX-SD-BG-375",
        label: "Steeldeck beugel L-375",
        screwSku: "HX-BV-SS",
        screwsPerAnchor: 2,         // VALIDEREN MET TOM
        nutSku: "HX-BV-GM-8",
      },
    },
    golfplaat: {
      label: "Golfplaten dak",
      railType: "alu",
      anchor: {
        sku: "HX-GC-CL",
        label: "Golfclip",
        connectorSku: "HX-GC-HV",
        nutSku: "HX-BV-GM-8",
      },
    },
  },

  /* --- Korte uitleg per component (getoond in materiaallijst) ------------ */
  componentBlurbs: {
    "HX-DH-VS":      "Verstelbare aluminium dakhaak voor pannendaken.",
    "HX-DH-33":      "Aluminium dakhaak 33-35 mm.",
    "HX-DH-43":      "Aluminium dakhaak 43-45 mm.",
    "HX-SD-BG-375":  "Steeldeck beugel L-375 mm incl. EPDM-afdichting.",
    "HX-SD-RA-610":  "Trapeze-montageprofiel 6,1 m voor steeldeck.",
    "HX-GC-CL":      "Golfclip voor bevestiging op golfplaten.",
    "HX-GC-HV":      "Hoekverbinder tussen golfclip en montagerail.",
    "HX-RA-475":     "Aluminium montagerail 4,75 m.",
    "HX-RA-590":     "Aluminium montagerail 5,90 m.",
    "HX-RA-710":     "Aluminium montagerail 7,10 m.",
    "HX-KL-EK-35-ZW":"Eindklem 35 mm zwart, sluit elke paneelrij af.",
    "HX-KL-MK-28-ZW":"Middenklem 28-35 mm zwart, tussen aangrenzende panelen.",
    "HX-BV-KS":      "Aluminium koppelstrip om railstukken te verbinden.",
    "HX-BV-EK":      "Eindkap voor montagerails.",
    "HX-BV-GM-8":    "Groefmoer M8.",
    "HX-BV-BT-820":  "RVS dakhaakbout M8×20.",
    "HX-BV-SS":      "Smeltschroef.",
  },
};
